export default "Le Fonds Vert de l'État finance jusqu'à 80% les projets de transition écologique des collectivités (rénovation bâtiments, éclairage, mobilité). Critères, enveloppes régionales et accompagnement.";
